import { MapContainer, TileLayer, Marker, Popup, Circle } from "react-leaflet";
import L from "leaflet";
import { useMemo } from "react";
import { FlyTo } from "@/components/AddressSearch";

// Fix marker icons in webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

function customIcon(label = "€", cls = "", photo = null) {
  const inner = photo ? `<img src="${photo.startsWith("/api/") ? BACKEND_URL + photo : photo}" style="width:100%;height:100%;object-fit:cover;border-radius:50%" alt=""/>` : label;
  return L.divIcon({
    className: "",
    html: `<div class="sc-marker ${cls}" style="${photo ? "padding:0;overflow:hidden" : ""}">${inner}</div>`,
    iconSize: [34, 34],
    iconAnchor: [17, 17],
  });
}

const initials = (name = "?") => name.split(" ").map((s) => s[0]).slice(0, 2).join("").toUpperCase();

export default function RoomsMap({ rooms, coaches = [], onSelect, onSelectCoach, focus = null }) {
  const center = useMemo(() => {
    if (rooms && rooms.length > 0) return [rooms[0].lat, rooms[0].lng];
    if (coaches.length > 0) return [coaches[0].lat, coaches[0].lng];
    return [46.7, 2.5];
  }, [rooms, coaches]);

  return (
    <MapContainer center={center} zoom={6} scrollWheelZoom className="rounded-2xl" data-testid="rooms-map">
      <TileLayer
        attribution='&copy; <a href="https://osm.org">OpenStreetMap</a>'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <FlyTo target={focus} />
      {focus && <Circle center={[focus.lat, focus.lng]} radius={focus.radius || 3000} pathOptions={{ color: "#10b981", fillOpacity: 0.08, weight: 1.5, dashArray: "4 4" }} />}
      {focus && <Marker position={[focus.lat, focus.lng]} icon={customIcon("●", "me")}><Popup>{focus.label || "Position choisie"}</Popup></Marker>}
      {rooms.map((r) => (
        <Marker
          key={r.id}
          position={[r.lat, r.lng]}
          icon={customIcon(`${Math.round(r.price_per_hour)}€`)}
          eventHandlers={{ click: () => onSelect && onSelect(r) }}
        >
          <Popup>
            <div className="min-w-[200px]">
              <div className="font-bold text-slate-900">{r.name}</div>
              <div className="text-xs text-slate-500">{r.neighborhood} · {r.city}</div>
              <div className="mt-1 text-sm">À partir de <b>{r.price_per_hour}€/h</b></div>
              <div className="mt-1 text-xs text-slate-600">{(r.disciplines || []).join(" · ")}</div>
            </div>
          </Popup>
        </Marker>
      ))}
      {coaches.map((c) => (
        <Marker
          key={`coach-${c.id}`}
          position={[c.lat, c.lng]}
          icon={customIcon(initials(c.name), "coach", c.photo_url)}
          eventHandlers={{ click: () => onSelectCoach && onSelectCoach(c) }}
        >
          <Popup>
            <div className="min-w-[200px]" data-testid={`coach-popup-${c.id}`}>
              <div className="text-[10px] uppercase tracking-wider font-bold text-orange-600">Coach {c.available === false ? "· indisponible" : "disponible"}</div>
              <div className="font-bold text-slate-900">{c.name}{c.verified ? " ✔︎" : ""}</div>
              <div className="text-xs text-slate-500">{c.city}</div>
              <div className="mt-1 text-xs text-slate-600">{(c.specialties || []).join(" · ")}</div>
              <a href={`/coachs/${c.id}`} className="mt-2 inline-block text-xs font-semibold text-orange-700 underline">Voir le profil</a>
            </div>
          </Popup>
        </Marker>
      ))}
    </MapContainer>
  );
}
